import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class AdministratorPersonnePhysique extends DivContainer {
  	constructor() {
	    super();
	    this.content = () => html`
		<personne-physique exercises="true"></personne-physique>
	    `;
	}
}

customElements.define ("administrator-personne-physique", AdministratorPersonnePhysique);
